<style lang="stylus">
.zoom {
  -webkit-transform: scale(0.1);
  transform: scale(0.1);
}

#app-toolbar
.v-toolbar__content {
  padding: 1;
}

.v-toolbar__title {
  margin-left: .5em;
  font-weight: 300;
  font-size: 21px;

  position {
    relative: top 1px
  }
}

.v-toolbar__items
.v-btn {
  text-transform: capitalize;
  font-size: 16px;
  font-weight: 400
}

.v-toolbar__extension {
  padding: 1
}

</style>

<template>
  <div>
    <v-app-bar app fixed hide-on-scroll elevate-on-scroll height="60px" v-resize="onResize" color="primary" dark
               v-if="hasInstitution">
      <v-img :src="require('@/assets/' + institutionLogoHead)" contain max-height="60" max-width="300"
             v-if="institutionLogoHead"
             @click.stop="toHomepage"></v-img>
      <v-img :src="require('@/assets/' + institutionLogo)" contain max-height="40" max-width="100"
             v-if="institutionLogo && !institutionLogoHead" @click.stop="toHomepage"></v-img>
      <v-toolbar-title>
        <div class="subtitle" v-if="!institutionLogoHead">{{ $t("Klientská zóna") }}</div>
        <div v-if="!institutionLogoHead" class="caption">
          {{ this.institution.institutionDesc }}
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-if="$vuetify.breakpoint.mobile === false">
        <!-- aktivity -->
        <v-toolbar-items v-if="hasCustomer">
          <v-btn text depressed @click="toCustomer" :aria-label="$t('Aktivity')"
                 :class="[ !basketHover && (isCustomer || customerHover) ? 'secondary primary--text' : '', 'mx-1' ]">
            <span class="hidden-sm-and-down mr-1" v-text="$t('Aktivity')"/>
            <v-icon class="hidden-md-and-up">account_box</v-icon>
          </v-btn>
        </v-toolbar-items>

        <!-- rezervace -->
        <v-toolbar-items v-if="hasAgreement">
          <v-btn text depressed @click="toReservations" :aria-label="$t('Rezervace')"
                 :class="[ isReservation && !basketHover && !customerHover ? 'secondary primary--text' : '', 'mx-1' ]">
            <span class="hidden-sm-and-down mr-1" v-text="$t('Rezervace')"/>
            <v-icon class="hidden-md-and-up">assignment</v-icon>
          </v-btn>
        </v-toolbar-items>

        <!-- eshop -->
        <v-toolbar-items v-if="$oauth2.hasAccessToken() && (!hasCustomer || hasAgreement)">
          <v-btn text depressed @click="toEshop" :aria-label="$t('Obchod')"
                 :class="[ isEshop && !basketHover && !customerHover ? 'secondary primary--text' : '', 'mx-1' ]">
            <span class="hidden-sm-and-down mr-1" v-text="$t('Obchod')"/>
            <v-icon class="hidden-md-and-up">store</v-icon>
          </v-btn>
        </v-toolbar-items>

        <!-- kosik -->
        <v-toolbar-items v-if="!hasItems">
          <v-tooltip botom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text style="min-width: 48px" class="mx-1">
                <span class="hidden-sm-and-down mr-1" v-text="$t('Košík')"/>
                <v-icon class="hidden-md-and-up">shopping_cart</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Košík je prázdný') }}</span>
          </v-tooltip>
        </v-toolbar-items>
        <v-toolbar-items v-else>
          <v-menu max-width="960" max-height="600" v-model="basketHover"
                  transition="fade-transition"
                  :open-on-hover="!isBasket" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click.native="basketHover = false"
                     @click="toBasket" text style="min-width: 48px"
                     :class="[ (isBasket || basketHover) && !customerHover ? 'secondary primary--text' : '', 'mx-1' ]">
                <span class="hidden-sm-and-down mr-1" v-text="$t('Košík')"/>
                <v-badge :color="badgeColor">
                  <span slot="badge">{{ basketItems.length }}</span>
                  <v-icon class="hidden-md-and-up">shopping_cart</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-list light dense>
              <!--            <v-row class="secondary px-0 py-0">-->
              <!--              <v-list-item>-->
              <!--                <v-list-item-content class="text-center">-->
              <!--                  <v-list-item-title class="color: primary&#45;&#45;text">{{ $t('Nákupní košík') }}</v-list-item-title>-->
              <!--                </v-list-item-content>-->
              <!--              </v-list-item>-->
              <!--            </v-row>-->
              <basket-item v-for="item in basketItems" :key="item.itemId" :value="item"
                           no-markdown></basket-item>
              <v-list-item to="/payment" v-if="necessaryCredit === 0" class="secondary">
                <v-list-item-action>
                  <v-icon>credit_card</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-row>
                    <v-col class="text-left">
                      <v-list-item-title class="color: primary--text">{{
                          $t('Dokončit nákup')
                        }}
                      </v-list-item-title>
                    </v-col>
                    <v-col class="text-right">
                      <v-list-item-title class="color: primary--text">
                        {{ basket.totalPrice | currency }}
                      </v-list-item-title>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <div v-for="(card, index) in cardsTotalCredit" :key="index">
                <v-list-item @click="rechargeCard(card.cardId)"
                             v-if="card.credit - card.availableCredit - chargedCredit(card) > 0">
                  <v-list-item-action>
                    <v-icon>credit_card</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-row>
                      <v-col class="text-left">
                        <v-list-item-title class="color: primary--text">{{
                            $t('Dobít kredit ')
                          }} {{
                            displayedCardNo(card.cardId)
                          }}
                        </v-list-item-title>
                      </v-col>
                      <v-col class="text-right">
                        <v-list-item-title class="color: primary--text">{{
                            (card.credit - card.availableCredit) -
                            chargedCredit(card) | currency
                          }}
                        </v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </template>

      <!-- ucet -->
      <v-btn icon @click.stop="drawer = !drawer">
        <v-list-item-avatar v-if="customer && customer.imageFile">
          <img :src="customer.imageUrl">
        </v-list-item-avatar>
        <v-icon v-else>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>

    <the-drawer :visible="drawer" @close="drawer = false" v-show="drawer"></the-drawer>
  </div>
</template>
<script>
import BasketMixin from "@/mixins/basket-mixin.js"
import CustomerMixin from "@/mixins/customer-mixin.js"
import InstitutionMixin from "@gravela/vue-component-library/src/mixins/institution-mixin.js"
import StorageMixin from "@/mixins/storage-mixin.js"
import CountryMixin from "@gravela/vue-component-library/src/mixins/country-mixin.js"
import TransformMixin from "@gravela/vue-component-library/src/mixins/transform-mixin.js"
import BasketItem from "@/components/basket-item.vue"
import TheDrawer from "@/components/the-drawer.vue"
import {
  eventBus
} from '@/main'

const _ = require('lodash')

export default {
  mixins: [
    BasketMixin,
    CountryMixin,
    CustomerMixin,
    InstitutionMixin,
    StorageMixin,
    TransformMixin
  ],
  components: {
    'the-drawer': TheDrawer,
    // 'customer-setting': CustomerSetting,
    // 'page-contacts': PageContacts,
    // 'setting-password': SettingPassword,
    'basket-item': BasketItem
  },
  data() {
    return {
      drawer: false,
      settingDialog: false,
      passwordDialog: false,
      instDialog: false,
      newPassword: null,
      valid: true,
      errorMessage: null,
      basketHover: false,
      customerHover: false,
      windowSize: {
        x: 0,
        y: 0
      }
    }
  },
  created() {
    eventBus.$on('logout-dialog-message', () => {
      this.settingDialog = false
      this.passwordDialog = false
      this.instDialog = false
    })
  },
  mounted() {
    const basket = Object.prototype.hasOwnProperty.call(window.localStorage, 'chip-bas-id') ? {
      basketId: window.localStorage.getItem('chip-bas-id')
    } : null
    this.fetchBasket(basket)
    this.onResize()

  },
  computed: {
    appBarSpace: {
      get() {
        return (this.windowSize.x - 960) / 2
      }
    },
    appBarPadding: {
      get() {
        return {
          padding: `0 ${this.appBarSpace}px`
        }
      }
    },
    appBarClass: {
      get() {
        // return "pl-lg-" + (window.innerWidth-960)/8
        return "px-lg-12"
      }
    },
    packageVersion: {
      get() {
        const v = JSON.stringify(require('../../package.json').version).replace(/['"]+/g, '')
        console.log("VERSION: " + v)
        return v
      }
    },
    badgeColor: {
      get() {
        return this.necessaryCredit > 0 ? "red" : "green darken-2"
      }
    },
    isReservation: {
      get() {
        return this.$route.name === "reservations"
      }
    },
    isEshop: {
      get() {
        return this.$route.name === "eshop"
      }
    },
    isBasket: {
      get() {
        return this.$route.name === "basket"
      }
    },
    isCustomer: {
      get() {
        return this.$route.name === "customer"
      }
    },
    lastVisit: {
      get() {
        return _.maxBy(this.customerData.visits, "startTime")
      }
    },
    daysFromLastVisit: {
      get() {
        var diff = -1
        if (this.lastVisit) {
          var today = new Date()
          today.setHours(23, 59, 59, 999)
          diff = Math.round(
              (today - new Date(this.lastVisit.startTime)) / (1000 * 60 * 60 * 24)
          )
        }
        return diff
      }
    }
  },
  methods: {
    toHomepage() {
      if (this.instHomepage) {
        window.location.href = this.instHomepage
      }
    },
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight}
    },
    resetPassword() {
      this.errorMessage = null
      this.$refs.form.reset()
    },
    setPassword() {
      if (this.newPassword) {
        this.$fetch('my/customers/passwords', {
          method: 'PUT',
          body: JSON.stringify({
            'password': this.$oauth2.b64Encode(this.newPassword)
          })
        })
            .then(() => {
              this.passwordDialog = false
              this.resetPassword()
            }).catch(() => console.log('reset password error'))
      }
    }
  },
  watch: {
    basketItems(value) {
      if (value.length > 0) {
        this.basketHover = true
        setTimeout(() => {
          this.basketHover = false
        }, 1200)
      }
    }
  }
}
</script>
